export default "__VITE_ASSET__a864d684__"